import { Home as HomeIcon, Hammer, Layers, ClipboardCheck, Building2, Wrench } from "lucide-react";

export const SERVICES = [
 {
 id: "custom-homes",
 title: "Custom Homes",
 Icon: HomeIcon,
 short: "Custom residences designed and built around the way you live.",
 description:
 "From the first sketch to the final walkthrough, we partner closely with each family to build a one-of-a-kind home that reflects their land, their lifestyle, and the quality they expect for decades to come.",
 link: { href: "/custom-home-builder-tahlequah-ok", label: "custom home builder in Tahlequah" },
 },
 {
 id: "remodels",
 title: "Remodels & Renovations",
 Icon: Hammer,
 short: "Thoughtful transformations of the homes you already love.",
 description:
 "We re-imagine kitchens, baths, and whole-home layouts with respect for the existing architecture, modernizing flow, finishes, and function without losing the character that makes a home yours.",
 link: { href: "/home-remodeling-tahlequah-ok", label: "home remodeling in Tahlequah" },
 },
 {
 id: "additions",
 title: "Home Additions",
 Icon: Layers,
 short: "Seamless square-footage that feels like it was always there.",
 description:
 "Whether it's a new master suite, an expanded great room, or a second story, we plan every transition, rooflines, materials, structure, so the addition looks and lives like part of the original home.",
 link: { href: "/home-additions-tahlequah-ok", label: "home additions in Tahlequah" },
 },
 {
 id: "residential-construction",
 title: "Residential Construction",
 Icon: Building2,
 short: "Full-scope ground-up residential builds across northeast Oklahoma.",
 description:
 "Site work, framing, mechanical systems, finishes, handled by a single accountable builder. We coordinate trusted local trades and stay on the job from groundbreaking to the day you get the keys.",
 },
 {
 id: "project-management",
 title: "Project Management",
 Icon: ClipboardCheck,
 short: "One point of contact. Clear timelines. Honest budgets.",
 description:
 "We run every project with detailed scheduling, transparent cost tracking, and consistent client communication, so you always know where things stand and what's coming next.",
 },
 {
 id: "craftsmanship",
 title: "Detail Carpentry & Finishes",
 Icon: Wrench,
 short: "Trim, cabinetry, and millwork that make a home feel custom.",
 description:
 "The difference between a builder-grade house and a real custom home lives in the details. We obsess over reveals, transitions, hardware, and finish work, the parts you see every day for the next thirty years.",
 },
];
